import { useState } from 'react'
import { useScroll, useMotionValueEvent } from 'motion/react'

import useIsMobile from '@/hooks/useIsMobile'

import { HeaderContextType } from '../Header.types'
import HeaderContext from './HeaderContext'

const OFFSET_Y = 100

const HeaderProvider = ({
  isHomepage,
  menu,
  children,
}: {
  isHomepage?: boolean
  menu: HeaderContextType['menu']
  children: React.ReactNode
}) => {
  const isMobile = useIsMobile()
  const { scrollY } = useScroll()

  const [isOpen, setIsOpen] = useState(false)
  const [compressed, setCompressed] = useState(false)

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (isMobile) return

    if (latest > OFFSET_Y) {
      setCompressed(true)
    } else {
      setCompressed(false)
    }
  })

  return (
    <HeaderContext.Provider
      value={{
        menu,
        compressed,
        isOpen,
        setIsOpen,
        isMobile,
        isHomepage,
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}

export default HeaderProvider
